import { gql } from '@apollo/client';

/**
 * dynamically generates a query containing the specified fields from the descriptor,
 * when applying it with apollo, use with fetchPolicy: 'no-cache' to avoid cache weird behaviour
 */
export function generateEnrichedQuery(fields: { key: string; path: string }[]) {
  const fieldSelections = fields
    .map(field => {
      const alias = field.key;
      return `${alias}: descriptor(path: "${field.path}")`;
    })
    .join('\n');

  const queryString = `
      query getEnrichedDataById($ids: [bigint!]) {
        dataProductInstance: marketplace_instances( where: {id: {_in: $ids}}) {
          entityId:id
          ${fieldSelections}
        }
      }
    `;

  return gql(queryString);
}

/**
 * Like generateEnrichedQuery but queries by external_id (string) and environment instead of numeric id to uniquely identify an instance.
 * when applying it with apollo, use with fetchPolicy: 'no-cache' to avoid cache weird behaviour
 */
export function generateEnrichedQueryByUrn(
  fields: { key: string; path: string }[],
) {
  const fieldSelections = fields
    .map(field => `${field.key}: descriptor(path: "${field.path}")`)
    .join('\n');

  const queryString = `
      query getEnrichedDataByExternalId($urns: [String!], $environmentId: bigint!) {
        marketplace_instances(where: {_and: { external_id: { _in: $urns }, environment_id: {_eq: $environmentId} }}) {
          externalId: external_id
          ${fieldSelections}
        }
      }
    `;

  return gql(queryString);
}
